import React from "react";

export const UnpricedTicket = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="12"
    viewBox="0 0 16 12"
    fill="none"
  >
    <path
      d="M14 12H2C0.895333 12 0 11.1047 0 10V7.33333L0.730667 7.33533C1.464 7.316 2.05467 6.76533 2.05467 6.02733C2.05467 5.28933 1.46533 4.688 0.733333 4.66733L0 4.66933V2C0 0.895333 0.895333 0 2 0H14C15.1047 0 16 0.895333 16 2V4.66667H15.408C14.7433 4.66667 14.1267 5.11933 14.0187 5.77467C13.8813 6.60933 14.524 7.33333 15.3333 7.33333H16V10C16 11.1047 15.1047 12 14 12Z"
      fill="#CFCDD6"
    />
  </svg>
);
